import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import { get } from '@rails/request.js'

// Connects to data-controller="school-select"
export default class extends Controller {
  static targets = ['item']

  connect() {
    this.select = new TomSelect(this.element, {
      labelField: 'name',
      valueField: 'id',
      load: (query, callback) => {
        fetch(`/app/degrees.json?q=${query}`)
          .then(response => response.json())
          .then(response => callback(response.data))
          .catch(() => callback());
      },
      create: (input, callback) => {
        get(`/app/degrees/new?degree[name]=${input}`, { responseKind: 'turbo-stream' })
      },
      render: {
        option: (data, escape) => {
          return this.option(data, escape)
        },
        item: (data, escape) => {
          return this.option(data, escape)
        }
      }
    });
  }

  disconnect() {
    this.select.destroy();
  }

  itemTargetConnected(element) {
    this.element.tomselect.sync()
    this.element.tomselect.setValue(element.value)
  }

  option(data, escape){
    return `<div  class="!flex gap-2 items-center focus:ring-0 focus:outline-none">${escape(data.text || data.name)}</div>`
  }
}
